/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Persona1Inputs */

const zh_landing_audience_persona1 = /** @type {(inputs: Landing_Audience_Persona1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`家教老师`)
};

const en_landing_audience_persona1 = /** @type {(inputs: Landing_Audience_Persona1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Tutors`)
};

const es_landing_audience_persona1 = /** @type {(inputs: Landing_Audience_Persona1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutores particulares`)
};

/**
* | output |
* | --- |
* | "Private Tutors" |
*
* @param {Landing_Audience_Persona1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_persona1 = /** @type {((inputs?: Landing_Audience_Persona1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Persona1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_persona1(inputs)
	if (locale === "en") return en_landing_audience_persona1(inputs)
	return es_landing_audience_persona1(inputs)
});